import React from 'react';
import s from './Layout.module.css';
import {Icons} from '../Sidebar/Icons';
const T={dashboard:'Dashboard',agendamentos:'Agendamentos',finalizados:'Finalizados',clientes:'Clientes',servicos:'Serviços',profissionais:'Profissionais',horarios:'Horários',link:'Link de Agendamento'};
export function Layout({user,logo,page,onMenu,children}){
  const ini=n=>(n||'?').split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase();
  return(
    <div className={s.shell}>
      <header className={s.top}>
        <div className={s.left}>
          <button className={s.mb} onClick={onMenu} aria-label="Menu"><Icons.Menu/></button>
          <h1 className={s.ti}>{T[page]||'—'}</h1>
        </div>
        <div className={s.right}>
          {logo?<img src={logo} alt="" className={s.av}/>:<div className={s.av2}>{ini(user?.nome)}</div>}
          <div className={s.ui}><span className={s.un}>{user?.nome}</span><span className={s.us}>{user?.empresa}</span></div>
        </div>
      </header>
      <main className={s.content}>{children}</main>
    </div>
  );
}
